import React from 'react';
import FactoryFlasher from '../flasher/FactoryFlasher';
import { User } from "../../types";

interface FactoryViewProps {
  user: User;
  onLogout: () => void;
}

const FactoryView: React.FC<FactoryViewProps> = ({ user, onLogout }) => {
  return (
    <div className="container mt-4 mb-3" style={{ maxWidth: '1400px' }}>
      <div className="responsive-page-header d-flex justify-content-between align-items-center border-bottom pb-3">
        <div className="d-flex align-items-center">
          <img className="responsive-logo me-3" src="/logo-mark.png" width="90" alt="Fluora Logo" />
          <div>
            <h1>Fluora Firmware</h1>
            <h4>Factory</h4>
          </div>
        </div>
        <button className="btn btn-danger" onClick={onLogout}>
          Logout
        </button>
      </div>

      <div className="mt-4">
        <FactoryFlasher user={user} />
      </div>
    </div>
  );
};

export default FactoryView;
